export default __webpack_public_path__ + "static/195-22f6546cdb52bb6b173b33702bfbaaca.jpg";